import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
  type: {
    type: String as PropType<'info' | 'success' | 'warning' | 'error'>,
    default: 'info'
  },
  icon: { type: String },
  hideIcon: { type: Boolean, default: false }
},
  setup(__props) {




const iconName = computed(() => __props.hideIcon ? false : __props.icon ? useIconLib(__props.icon) : undefined)


return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    type: __props.type,
    icon: _unref(iconName),
    variant: "tonal"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["type", "icon"]))
}
}

})